import React, { useState } from 'react'
import { Button, Card } from 'react-bootstrap'
import { Row, Col } from 'react-bootstrap'
import useUser from '../../../hooks/use-user'
import UserImage from '../image'
import UserGrade from '../grade-field'
import { X } from 'react-bootstrap-icons'
import SpinnerContainer from '../../common/spinner-container'
import EnrolledCourses from '../enrolled-courses'
import ModeSelector from '../../common/button-selector'
import Interests from '../../user-interests/section'
import Goals from '../../goals/section'
import UserReflections from '../../user-reflections/section'
import useCurrentUser from '../../../hooks/use-current-user'
import MessageButton from '../message-button'
import ProgressGraph from '../../progress/dimensions-bar-graph'
import RoleField from '../role-field'
import DeleteButton from './delete-button'
import NameField from '../name-field'
import Email from '../email'
import StudentIdField from '../student-id-field'
import { UserWellnessHour } from '../../../features/auto-enrollment'
import { ShowForAdmin } from '../../visibility'
import { UserProfileSection } from '../../../features/user-profile'

const ProfileRow = ({
    children,
    style = {}
}) => {
    return (
        <div style={{
            ...style,
            paddingLeft: '20px',
            paddingRight: '20px',
            paddingBottom: '15px',
            paddingTop: '15px'
        }}>
            {children}
        </div>
    )
}

const MODES = {
    PROFILE: 'profile',
    EXPERIENCES: 'experiences',
    PROGRESS: 'progress',
}

const UserProfile = ({
    userId,
    onClose
}) => {
    const { canMessage, isAdmin } = useCurrentUser()
    const [ mode, setMode ] = useState(MODES.PROFILE)
    const {
        isBusy,
        user,
        isStudent,
    } = useUser({ id: userId })

    if (isBusy) {
        return (<SpinnerContainer />)
    }

    const renderMode = () => {
        if (!isStudent) {
            return null
        }

        switch(mode) {
        case MODES.EXPERIENCES:
            return (<EnrolledCourses userId={userId} />)
        case MODES.PROFILE:
            return (
                <div>
                    <ProfileRow>
                        <Interests userId={userId} variant='secondary' />
                    </ProfileRow>
                    <ProfileRow>
                        <Goals userId={userId} />
                    </ProfileRow>
                    <ProfileRow>
                        <UserReflections userId={userId}  />
                    </ProfileRow>
                    <ShowForAdmin>
                        <ProfileRow>
                            <UserProfileSection label="Wellness Hour">
                                <UserWellnessHour userId={userId} />
                            </UserProfileSection>
                        </ProfileRow>
                    </ShowForAdmin>
                </div>
            )
        case MODES.PROGRESS:
            return (
                <ProgressGraph userId={userId} />
            )
        default:
            return null
        }
    }

    return (
        <Row style={{ height: '100%', maxWidth: '99%' }}>
            <Col med={12} lg={6} style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                <div style={{ flexGrow: '1', padding: '16px', backgroundColor: 'rgb(240, 249, 255)', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                    <div style={{ display: !isStudent ? 'none' : undefined }}>
                        <ModeSelector
                            options={Object.values(MODES)}
                            value={mode}
                            onChange={setMode}
                        />
                    </div>    
                    <div style={{ height: '150px'}} className='text-center'><UserImage user={user} /></div>
                    
                    <div>
                        <NameField user={user} canEdit={isAdmin} />
                        <Email user={user} />
                    </div>
                    
                </div>
                <div style={{ backgroundColor: 'rgb(38, 153, 251)', color: 'white', padding: '16px', height: '200px', display: 'flex', flexDirection: 'column'  }}>
                    <div style={{ paddingBottom: '5px'}}><RoleField user={user} canEdit={isAdmin} /></div>
                    <div style={{ paddingBottom: '5px'}}><UserGrade user={user} canEdit={isAdmin} /></div>
                    <div style={{ paddingBottom: '5px'}}><StudentIdField user={user} canEdit={isAdmin} /></div>
                    <div className='three-line-ellipsis'>{user.biography}</div>
                </div>
            </Col>
            <Col med={12} lg={6} style={{ height: '100%', display: 'flex', flexDirection: 'column', padding: '16px' }}>
                {Boolean(onClose) &&
                    <div className="text-right" ><Button variant='link' onClick={() => onClose()} ><X size={40} /></Button></div>
                }
                <Card style={{ flexGrow: '1', overflowY: 'auto'}}>
                    <Card.Body>
                        {renderMode()}
                    </Card.Body>
                </Card>
                <div style={{ display: 'flex', justifyContent: 'space-evenly', padding: '10px 0px' }}>
                    <DeleteButton variant='secondary' userId={userId}>Delete User</DeleteButton>
                    <MessageButton recipientId={userId} >SEND MESSAGE</MessageButton>
                </div>
            </Col>
        </Row>
    )
}

export default UserProfile